import React from 'react';
import { Step } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { theme as themeConfig } from '../../themes/themes';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'absolute',
        bottom: '0',
        left: '0',
    },
    step: {
        flex: 1,
        padding: '4px 0',
        textAlign: 'center',
        background: themeConfig.neutral.gray[600],
    },
    activeStep: {
        background: themeConfig.text.primary,
    },
}));

function StepperLine({ activeStep }) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={`${classes.step} ${activeStep >= 1 ? classes.activeStep : ''}`}>
                <Step />
            </div>
            <div className={`${classes.step} ${activeStep >= 2 ? classes.activeStep : ''}`}>
                <Step />
            </div>
            <div className={`${classes.step} ${activeStep >= 3 ? classes.activeStep : ''}`}>
                <Step />
            </div>
        </div>
    );
}

export default StepperLine;
